import * as Cybersecurity_en from './Cybersecurity.en.js';
import * as Cybersecurity_es from './Cybersecurity.es.js';

const CybersecurityTuple = [
  { type: 'Cybersecurity', language: 'en', object: Cybersecurity_en.default },
  { type: 'Cybersecurity', language: 'es', object: Cybersecurity_es.default },
];

export default CybersecurityTuple;
